/**
 * Created by mac on 12/14/20
 */

const UnitView = cc.Node.extend({
    ctor: function (unit) {
        this._super();

        this.unit = unit;

        this.additionalViews = {};

        const sprite = UnitView.getUnitImage(unit);

        this.setUnitImage(sprite);

        unit.setView(this);

        this.createComponentViews();
        this.restoreState();

        if (this.shouldMarkAsLast()) {
            this.markLast();
        }
    },

    createComponentViews: function () {
        this.unit.components.forEach(function (component) {
            ViewFactory(component, this);
        }, this);
    },

    shouldMarkAsLast: function () {
        if (this.unit.findComponent(ThirdElement)) {
            return false;
        }
        
        return this.unit.isLast() || this.unit.getData().unmergeable;
    },

    setUnitImage: function (sprite) {
        if (this.sprite) {
            this.sprite.removeFromParent();
        }
        this.sprite = sprite;

        sprite.saveStack = true;

        const unitSize = cleverapps.styles.FlatFieldView.cell;

        this.setAnchorPoint(0.5, 0.5);
        sprite.setAnchorPoint(0.5, 0);

        this.setContentSize2(unitSize);
        sprite.setAlignment(this.width / 2, (unitSize.height - this.sprite.height) / 2);

        this.addChild(sprite);
    },

    restoreState: function () {
        this.updateCustomerMark();
    },

    cleanup: function () {
        this._super();

        this.unit.removeView();
    },

    clearAnimations: function () {
        this.unit.clearAnimations();

        ["squeezeAction", "mergeAction", "mergeAnimateAction", "addAnimationAction", "acceptAction"].forEach(function (actionName) {
            const action = this[actionName];
            if (action && !action.isDone()) {
                this.stopAction(action);
            }
            delete this[actionName];
        }, this);
    }
});

UnitView.prototype.checkTouchInside = function (touch) {
    if (!this.isDisplayed()) {
        return false;
    }

    const point = this.convertTouchToNodeSpace(touch);

    return UnitView.targetContainPoint(this, point);
};

UnitView.prototype.onRemove = function () {
    this.removeFromParent();
};

UnitView.prototype.getSpawnStart = function (parentUnit, options) {
    const fieldView = Merge2.current.field.getMapView();

    let start;
    if (options.fromNode) {
        const cellPos = fieldView.alignInGrid(this.unit.x, this.unit.y);
        start = parentUnit.parent ? this.getRelativeCoordinates(parentUnit) : cc.p(parentUnit);
        start.x -= cellPos.x;
        start.y -= cellPos.y;
    } else {
        start = cc.pSub(fieldView.toScreen(parentUnit.x, parentUnit.y), fieldView.toScreen(this.unit.x, this.unit.y));
    }

    const startScale = options.startScale || 0.7;

    this.setScaleX(typeof startScale === "object" ? startScale.x : startScale);
    this.setScaleY(typeof startScale === "object" ? startScale.y : startScale);

    return fieldView.alignPositionInGrid(this.unit.x, this.unit.y, start);
};

UnitView.prototype.spawn = function (parentUnit, id, options) {
    const callback = options.callback || function () {};

    this.stopAllActions();
    this.hideAdditionalViews();

    const realParent = this.getParent();
    const movingNode = cleverapps.Scenes.GetMovingNode(this);
    this.replaceParentSamePlace(movingNode, {
        keepScale: true
    });

    const start = this.getSpawnStart(parentUnit, options);
    const dist = { x: this.x - start.x, y: this.y - start.y };
    this.setAlignment(start.x, start.y);

    let path;
    if (options.path) {
        path = new cleverapps.Particles(bundles.particle.jsons.particles_spawn_json, bundles.particle.frames.particle_texture);
        movingNode.addChild(path);
        path.followTarget(this);
    }

    let gift;
    if (options.gift) {
        gift = new cleverapps.Spine(bundles.merge_animations.jsons.spawn_gift_json);
        gift.setAnimation(0, "idle", false);
        gift.setPosition(this.width / 2, this.height / 2);
        this.addChild(gift);
        this.sprite.setVisible(false);
    }

    const time = 0.3 * (0.5 + 0.001 * cc.pLength(dist));

    const normalizedReverseDir = cc.pNormalize(cc.p(-dist.x, -dist.y));
    const offset = cc.pMult(normalizedReverseDir, 10);

    const endPosX = this.x + dist.x;
    const endPosY = this.y + dist.y;

    const spawnHeight = !options.fromNode ? 0 : cleverapps.styles.UnitView.spawnHeight;

    let appearAnimation = new cc.Spawn(
        new cc.Sequence(
            new cc.ScaleTo(time * 0.5, 1.3).easing(cc.easeIn(1)),
            new cc.ScaleTo(time * 0.5, 0.8).easing(cc.easeOut(1))
        ),
        new cc.JumpAnimation(time, this, { x: dist.x + offset.x, y: dist.y + offset.y }, spawnHeight)
    );

    if (options.spawnEffect) {
        appearAnimation = new cc.Spawn(
            appearAnimation,
            cleverapps.effects.fireAction(options.spawnEffect)
        );
    }

    const finishAnimation = new cc.Spawn(
        new cc.ScaleTo(0.3, 1).easing(cc.easeBackOut()),
        new cc.MoveTo(0.3, endPosX, endPosY).easing(cc.easeOut(1))
    );

    const actions = [
        new cc.Hide(),
        new cc.DelayTime(id * 0.1),
        new cc.Show(),
        appearAnimation,
        cleverapps.effects.fireAction("merge.spawn.landing"),
        new cc.CallFunc(() => {
            if (bundles.merge_animations.jsons.spawn_wave_json) {
                const spawnWave = new cleverapps.Spine(bundles.merge_animations.jsons.spawn_wave_json);
                spawnWave.setAnimation(0, "animation", false);
                spawnWave.setCompleteListenerRemove();
                spawnWave.setPosition(this.width / 2, this.height / 2);
                this.addChild(spawnWave, -1);
            }
        }),
        finishAnimation

    ];

    if (gift) {
        actions.push(
            new cc.CallFunc(() => {
                Merge2.current.showHint(this, Messages.get("LuckyDrop"));

                gift.setAnimation(0, "open", false);
                gift.setCompleteListenerRemove(() => {
                    if (this.rays) {
                        this.rays.setAnimation(0, "close");
                        this.rays.setCompleteListenerRemove();
                        delete this.rays;
                    }
                });
                gift.replaceParentSamePlace(movingNode);
            }),
            new cc.DelayTime(1.2),
            new cc.CallFunc(() => {
                this.sprite.setVisible(true);
                this.rays = StandartAnimations.rays(this);
            }),
            new cc.DelayTime(gift.getAnimationDuration("open") - 1.2)

        );
    }

    this.spawnAction = this.runAction(new cc.Sequence(actions)).setFinalize(() => {
        this.replaceParent(realParent);
        this.setVisible(true);
        if (this.rays) {
            this.rays.removeFromParent();
            delete this.rays;
        }

        if (gift && gift.parent) {
            gift.removeFromParent();
        }
        this.sprite.setVisible(true);
        this.setScale(1);
        this.setPosition(this.parent.convertToNodeSpace(movingNode.convertToWorldSpace(cc.p(endPosX, endPosY))));
        this.showAdditionalViews();

        if (path) {
            path.stop();
        }
        callback();
    });
};

UnitView.prototype.squeeze = function () {
    if (this.squeezeAction) {
        this.stopAction(this.squeezeAction);
    }

    this.squeezeAction = this.runAction(StandartAnimations.squeeze(this, { dScale: 0.08 }));
};

UnitView.prototype.handleClick = function () {
    if (this.unit.handleClick()) {
        return true;
    }

    if (!this.moving) {
        this.stopAllActions();

        this.unit.squeeze();
    }

    cleverapps.effects.fire("merge.field.click");

    return true;
};

UnitView.prototype.handleDragStart = function (touch) {
    if (!this.unit.handleDragStart()) {
        return false;
    }

    this.stopAllActions();

    this.hideAdditionalViews();

    this.dragNode = new cc.Node();
    const movingNode = cleverapps.Scenes.GetMovingNode();
    movingNode.addChild(this.dragNode);
    const scale = cc.Base.AdjustScaleTo(this, movingNode);
    this.dragNode.setScale(scale.x, scale.y);
    this.replaceParentSamePlace(this.dragNode);

    const position = this.parent.convertToNodeSpace(touch.getStartLocation());
    this.startDragDelta = cc.p(this.x - position.x, this.y - position.y);

    this.dragStartTime = cleverapps.timeouts.getTime();
    const dragOffsetY = cleverapps.styles.UnitView.dragOffsetY;
    this.runAction(new cc.MoveBy(0.1, 0, dragOffsetY));

    cleverapps.effects.fire("merge.drag.start");

    return true;
};

UnitView.prototype.handleFollowPointer = function (touch) {
    const position = this.parent.convertTouchToNodeSpace(touch);

    if (this.startDragDelta) {
        position.x += this.startDragDelta.x;
        position.y += this.startDragDelta.y;
    }

    let dragOffsetY = cleverapps.styles.UnitView.dragOffsetY;
    if (this.dragStartTime) {
        dragOffsetY *= Math.min(1, (cleverapps.timeouts.getTime() - this.dragStartTime) / 100);
    }
    position.y += dragOffsetY;

    const size = this.getGlobalBoundingBox();
    const globalPos = this.parent.convertToWorldSpace(position);
    const bgSize = cleverapps.resolution.getBgSize();
    const clampedPosition = cc.pClamp(globalPos, cc.p(size.width / 2, size.height / 2), cc.p(bgSize.width - size.width / 2, bgSize.height - size.height / 2));

    this.setAlignment(this.parent.convertToNodeSpace(clampedPosition));
};

UnitView.prototype.handleDragMove = function (dropTarget) {
    const mapView = Merge2.current.field.getMapView();
    const move = mapView.getCellByCoordinates(mapView.convertToNodeSpace(this.parent.convertToWorldSpace(this.getPosition())), true);

    if (dropTarget) {
        if (!this.acceptAction) {
            this.acceptAction = this.runAction(new cc.RepeatForever(new cc.Sequence(
                new cc.DelayTime(0.1),
                new cc.ScaleTo(0.15, 1.15).easing(cc.easeInOut(2)),
                new cc.ScaleTo(0.20, 0.97).easing(cc.easeInOut(2)),
                new cc.ScaleTo(0.20, 1.15).easing(cc.easeInOut(2)),
                new cc.ScaleTo(0.25, 1).easing(cc.easeInOut(2)),
                new cc.DelayTime(0.3)
            )));
        }
    } else if (this.acceptAction) {
        this.stopAction(this.acceptAction);
        this.acceptAction = undefined;
    }

    this.unit.handleDragMove(move.x, move.y);
};

UnitView.prototype.handleDragEnd = function (cancelled, dropTarget) {
    this.removePath();

    delete this.startDragDelta;
    delete this.dragStartTime;

    const mapView = Merge2.current.field.getMapView();
    this.replaceParentSamePlace(mapView.animations);
    if (this.dragNode) {
        this.dragNode.removeFromParent();
        delete this.dragNode;
    }

    if (this.acceptAction) {
        this.stopAction(this.acceptAction);
        this.acceptAction = undefined;
    }

    if (dropTarget && dropTarget.handleDropEnd(this)) {
        cancelled = true;
    }
    
    this.unit.handleDragEnd(cancelled);
};

UnitView.prototype.removePath = function () {
    if (this.path) {
        this.path.stop();
        this.path = undefined;
    }
};

UnitView.prototype.move = function (options) {
    this.hideAdditionalViews();

    this.moving = true;
    options = options || {};
    const mapView = Merge2.current.field.getMapView();

    const pos = mapView.alignInGrid(this.unit.x, this.unit.y);

    this.setScale(1);
    this.setVisible(true);
    this.stopAllActions();
    this.removePath();

    this.replaceParentSamePlace(mapView.animations);

    let actions = [];
    actions.push(options.isNewPlace ? UnitView.fallDown(this, bundles.merge_animations.jsons.dragend_json)
        : new cc.MoveTo(0.25, pos).easing(cc.easeOut(2)));
    
    const normalizeVector = cc.pNormalize(cc.pSub(pos, this.getPosition()));
    const length = cleverapps.styles.UnitView.pushingLength;

    actions = [
        new cc.MoveTo(0.15, cc.pAdd(pos, cc.pMult(normalizeVector, length))).easing(cc.easeCubicActionOut()),
        new cc.CallFunc(() => {
            this.showAdditionalViews();
        }),
        new cc.MoveTo(0.1, pos).easing(cc.easeInOut(2))
    ];

    if (options.isPushed) {
        const baseZOrder = this.getLocalZOrder();
        this.setLocalZOrder(-1);

        actions.push(new cc.CallFunc(this.setLocalZOrder.bind(this, baseZOrder)));
    }

    if ((options.isPushed || !options.isNewPlace) && bundles.game.urls.swap_effect) {
        actions.push(cleverapps.effects.fireAction("merge.unit.swap"));
    } else {
        actions.push(cleverapps.effects.fireAction("merge.spawn.landing"));
    }

    this.runAction(new cc.Sequence(actions).setFinalize(() => {
        if (!this.unit.isLifted() && Merge2.current.field.getUnit(this.unit.x, this.unit.y) === this.unit) {
            mapView.addObjectView(FlatFieldView.LAYER_UNITS, this.unit.x, this.unit.y, this);
        }

        this.moving = false;
    }));
};

UnitView.prototype.playDestruction = function (silent) {
    this.stopAllActions();
    this.removePath();

    this.explodeAnimation(silent);
};

UnitView.prototype.explodeAnimation = function (silent) {
    if (this.unit.findComponent(ThirdElement)) {
        cleverapps.effects.fire("merge.unit.destroy");

        const movingNode = cleverapps.Scenes.GetMovingNode(this);
        this.replaceParentSamePlace(movingNode);

        this.sprite.setAnimation(0, "disappearance", false);
        this.sprite.setCompleteListenerOnce(this.removeFromParent.bind(this));
        return;
    }

    let json = bundles.merge_animations.jsons.destruction_json;

    if (bundles.merge_animations.jsons.destruction_on_complete_json
        && this.unit.components.some((component) => component instanceof Merge2Generator || component instanceof CupComponent)) {
        json = bundles.merge_animations.jsons.destruction_on_complete_json;
    }

    const animation = new cleverapps.Spine(json);
    animation.setAlignment(this.width / 2, this.height / 2);
    animation.setAnimation(0, "animation", false);
    animation.setCompleteListenerRemove(this.removeFromParent.bind(this));
    animation.setSafeToRemove();
    this.addChild(animation);

    const movingNode = cleverapps.Scenes.GetMovingNode(this);

    this.replaceParentSamePlace(movingNode);
    animation.replaceParentSamePlace(movingNode);

    cleverapps.effects.fire("merge.unit.destroy");

    if (!silent) {
        if (json === bundles.merge_animations.jsons.destruction_on_complete_json) {
            this.runAction(
                new cc.Sequence(
                    new cc.DelayTime(0.2),
                    new cc.RemoveSelf()
                )
            );
        } else {
            this.runAction(
                new cc.Sequence(
                    new cc.ScaleTo(0.2, 1.3, 1.3).easing(cc.easeIn(1)),
                    new cc.ScaleTo(0.2, 0.7, 0.7).easing(cc.easeOut(1)),
                    new cc.RemoveSelf()
                )
            );
        }
    }
};

UnitView.prototype.playAddAnimation = function () {
    const fieldView = Merge2.current.field.getMapView();
    const shine = new cleverapps.Spine(bundles.merge.jsons.buildable_above_json);
    shine.setLocalZOrder(1);
    shine.setAnimation(0, "animation_bonus", false);
    shine.setCompleteListenerRemove();
    shine.setSafeToRemove();
    fieldView.alignViewInGrid(this.unit.x, this.unit.y, shine);
    fieldView.animations.addChild(shine);

    this.setVisible(false);
    this.setScale(0.3);
    this.addAnimationAction = this.runAction(new cc.Sequence(
        new cc.DelayTime(0.3),
        cleverapps.effects.fireAction("thirdelement.appear"),
        new cc.Show(),
        new cc.ScaleTo(0.4, 1.3),
        new cc.ScaleTo(0.2, 1)
    )).setFinalize(() => {
        this.setScale(1);
        this.setVisible(true);
    });
};

UnitView.prototype.updateCustomerMark = function () {
    if (cleverapps.config.demoMode || cleverapps.gameModes.hideGuideAndProgress) {
        return;
    }

    if (this.unit.customerMark) {
        if (this.removeMarkAction) {
            this.stopAction(this.removeMarkAction);
            delete this.removeMarkAction;
        }

        const styles = cleverapps.styles.UnitView;
        if (bundles.customer_check_marks.frames.customer_check_mark_bg) {
            const markBg = this.markBg = new cc.Sprite(bundles.customer_check_marks.frames.customer_check_mark_bg);
            markBg.setAnchorPoint(0, 0);
            markBg.setAlignment(styles.mark);

            const mark = new cc.Sprite(bundles.customer_check_marks.frames.customer_check_mark_flat);
            markBg.addChild(mark);
            mark.setAlignment(markBg.width / 2, markBg.height / 2);

            this.addChild(markBg);
        }

        const unitMarkerUnderlay = new cc.Sprite(bundles.merge.frames.unit_ready_marker_underlay);
        unitMarkerUnderlay.setAlignment({ x: { align: "center" }, y: { align: "center" } });
        const unit = this.unit;
        const fieldView = Merge2.current.field.getMapView();

        unitMarkerUnderlay.animateAppear = (callback) => {
            unitMarkerUnderlay.stopAllActions();
            if (cleverapps.config.name === "ladacha") {
                unitMarkerUnderlay.runAction(new cc.Sequence(
                    new cc.FadeTo(0, 0),
                    new cc.Show(),
                    new cc.FadeIn(0.2)
                )).setFinalize(callback);
            } else {
                UnitView.animateAppear.call(unitMarkerUnderlay, callback);
            }
            const tile = fieldView.getTileView(unit.x, unit.y);
            unitMarkerUnderlay.replaceParent(tile);
        };

        unitMarkerUnderlay.animateHide = (callback) => {
            unitMarkerUnderlay.stopAllActions();
            if (cleverapps.config.name === "ladacha") {
                unitMarkerUnderlay.runAction(new cc.Sequence(
                    new cc.FadeOut(0.05),
                    new cc.Hide()
                )).setFinalize(callback);
            } else {
                UnitView.animateHide.call(unitMarkerUnderlay, callback);
            }
        };

        this.createAdditionalView("unitMarkerUnderlay", unitMarkerUnderlay, true);
        const tile = fieldView.getTileView(unit.x, unit.y);
        unitMarkerUnderlay.replaceParent(tile);
    } else if (!this.removeMarkAction) {
        this.removeMarkAction = this.runAction(new cc.DelayTime(0.2)).setFinalize(() => {
            if (this.removeMarkAction) {
                delete this.removeMarkAction;
            }

            this.removeMark();
        });
    }
};

UnitView.prototype.showMissionMark = function (mission) {
    const MarkCtor = mission.markView;
    const markView = new MarkCtor();
    this.addChild(markView);
};

UnitView.prototype.removeMark = function () {
    if (this.markBg) {
        this.markBg.removeFromParent();
        delete this.markBg;
    }
    this.removeAdditionalView("unitMarkerUnderlay", true);
};

UnitView.prototype.createAdditionalView = function (type, view, silent) {
    const oldView = this.additionalViews[type];

    view.animateAppear = view.animateAppear || UnitView.animateAppear;
    view.animateHide = view.animateHide || UnitView.animateHide;
    this.additionalViews[type] = view;
    this.addChild(view, 5);

    if (!oldView) {
        if (!silent) {
            view.animateAppear();
        }
        return;
    }

    if (silent) {
        oldView.removeFromParent();
        return;
    }

    view.setVisible(false);

    oldView.animateHide(() => {
        oldView.removeFromParent();

        view.setVisible(true);
        view.animateAppear();
    });
};

UnitView.prototype.removeAdditionalView = function (type, silent) {
    const oldView = this.additionalViews[type];
    delete this.additionalViews[type];

    if (!oldView) {
        return;
    }

    if (silent) {
        oldView.removeFromParent();
        return;
    }

    oldView.animateHide(() => {
        oldView.removeFromParent();
    });
};

UnitView.prototype.showAdditionalView = function (type) {
    const view = this.additionalViews[type];
    if (view) {
        view.animateAppear();
    }
};

UnitView.prototype.hideAdditionalView = function (type) {
    const view = this.additionalViews[type];
    if (view) {
        view.animateHide();
    }
};

UnitView.prototype.hasAdditionalView = function (type) {
    return !!this.additionalViews[type];
};

UnitView.prototype.showAdditionalViews = function () {
    for (const type in this.additionalViews) {
        this.additionalViews[type].animateAppear();
    }
};

UnitView.prototype.hideAdditionalViews = function () {
    for (const type in this.additionalViews) {
        this.additionalViews[type].animateHide();
    }
};

UnitView.prototype.removeAdditionalViews = function () {
    for (const type in this.additionalViews) {
        this.additionalViews[type].removeFromParent();
        delete this.additionalViews[type];
    }
};

UnitView.prototype.setImageOpacity = function (opacity, temp) {
    if (!temp) {
        this.baseOpacity = opacity;
    }

    this.sprite.setOpacity(opacity);
};

UnitView.prototype.restoreOpacity = function () {
    this.sprite.setOpacity(this.baseOpacity !== undefined ? this.baseOpacity : 255);
};

UnitView.prototype.setImageColor = function (color) {
    this.sprite.setColor(color);
};

UnitView.prototype.restoreColor = function () {
    this.sprite.setColor(cleverapps.styles.COLORS.WHITE);
};

UnitView.prototype.onDeletePressed = function () {
    if (!confirm(`Delete unit "${this.unit.code}'?`)) {
        return;
    }

    this.unit.remove();
};

UnitView.prototype.getAnimation = function () {
    if (this.sprite instanceof cleverapps.Spine) {
        return this.sprite;
    }
};

UnitView.prototype.markLast = function () {
    const bundle = bundles.merge.jsons.mark_last_json;
    if (!bundle) {
        return;
    }

    if (!this.markLastAnimation) {
        this.markLastAnimation = new cleverapps.Spine(bundle);
    }

    const mark = this.markLastAnimation;

    mark.setAnimation(0, "idle", true);
    mark.setAlignment(cleverapps.styles.UnitView.markLast);

    this.addChild(mark);
};

UnitView.prototype.canSmile = function () {
    return this.sprite instanceof cleverapps.Spine
        && this.sprite.hasAnimation("smile")
        && this.getNumberOfRunningActions() === 0;
};

UnitView.prototype.smile = function () {
    if (this.sprite.isVisible()) {
        this.sprite.setAnimationAndIdleAfter("smile", "idle");
    }
};

UnitView.GetUnitBundle = function (unit) {
    if (!Families[unit.code] || !Families[unit.code].units[unit.stage]) {
        throw `No such unit ${unit.code}_${unit.stage}`;
    }
    return bundles[`unit_${unit.code}`];
};

UnitView.UnitIconFrame = function (unit) {
    const unitKey = `unit_${unit.code}_${unit.stage + 1}`;
    const bundle = UnitView.GetUnitBundle(unit);
    const res = bundle.frames[unitKey] || bundle.frames[`${unitKey}_frame`];
    return res && res.resolve();
};

UnitView.UnitIconJson = function (unit) {
    const unitKey = `unit_${unit.code}_${unit.stage + 1}`;
    const bundle = UnitView.GetUnitBundle(unit);
    const res = bundle.jsons[unitKey];
    return res && res.resolve();
};

UnitView.getUnitImage = function (unit, options) {
    options = options || {};
    const code = unit.code;

    if (unit.unknown) {
        return new cc.Sprite(bundles.units_library.frames.icon_unknown);
    }

    const json = UnitView.UnitIconJson(unit);
    const frame = UnitView.UnitIconFrame(unit);

    if (!json && !frame) {
        throw new Error(`Not found frame unit_${code}_${unit.stage + 1}`);
    }

    let image;

    if (frame && (options.preferStatic || !json)) {
        try {
            image = new cc.Sprite(frame);
        } catch (e) {
            throw new Error(`can't create unit sprite ${unit.code} ${unit.stage} ${frame} ${e}`);
        }
    }

    if (json) {
        try {
            image = new cleverapps.Spine(json);
        } catch (e) {
            throw new Error(`can't create unit spine ${unit.code} ${unit.stage} ${json} ${e}`);
        }

        UnitView.applyDefaultAnimation(image, unit, options.defaultAnimation);
        if (options.preferStatic) {
            image.clearTrack(0);
        }
    }

    if (cleverapps.config.debugMode) {
        image.debugUnitImage = { code: unit.code, stage: unit.stage };
    }

    return image;
};

UnitView.applyDefaultAnimation = function (animation, unit, defaultAnimation) {
    if (defaultAnimation && animation.hasAnimation(defaultAnimation)) {
        animation.setAnimation(0, defaultAnimation, true);
    } else {
        animation.setAnimation(0, animation.hasAnimation("idle") ? "idle" : "animation", true);
    }

    animation.setSafeToRemove();
};

UnitView.targetContainPoint = function (unitView, point) {
    return cc.rectContainsPoint(cc.rect(0, 0, unitView.width, unitView.height), point);
};

UnitView.animateAppear = function (callback) {
    this.runAction(new cc.Sequence(
        new cc.ScaleTo(0, 0.5),
        new cc.Show(),
        new cc.ScaleTo(0.2, 1, 1).easing(cc.easeIn(1))
    )).setFinalize(callback);
};

UnitView.animateHide = function (callback) {
    this.runAction(new cc.Sequence(
        new cc.ScaleTo(0.05, 0.5, 0.5).easing(cc.easeIn(1)),
        new cc.Hide()
    )).setFinalize(callback);
};

UnitView.fallDown = function (node, dustAnimation) {
    dustAnimation = dustAnimation || bundles.animations_library.jsons.fall_down_json;

    const mapView = Merge2.current.field.getMapView();

    const pos = mapView.alignInGrid(node.unit.x, node.unit.y);

    return new cc.Spawn(
        new cc.MoveBy(0.25, pos.x - node.x, 0).easing(cc.easeOut(2)),
        new cc.MoveBy(0.15, 0, pos.y - node.y).easing(cc.easeIn(1)),
        new cc.CallFunc(() => {
            const dustSpine = new cleverapps.Spine(dustAnimation);
            dustSpine.setAlignment({
                x: { align: "center" },
                y: { align: "center" }
            });
            dustSpine.setCompleteListenerRemove();
            dustSpine.setSafeToRemove();
            dustSpine.setLocalZOrder(-1);
            mapView.addObjectView(FlatFieldView.LAYER_UNITS, node.unit.x, node.unit.y, dustSpine);
            dustSpine.setAnimation(0, "animation", false);

            cleverapps.effects.fire("merge3.unit.fall");
        })
    );
};

cleverapps.styles.UnitView = {
    pushingLength: 15,
    preview: { anchorX: 0.47, anchorY: 0.28 },
    minimalSize: {
        width: 115,
        height: 115
    },

    spawnHeight: 240,
    dragOffsetY: 30,

    mark: {
        x: { align: "center", dx: 35 },
        y: { align: "bottom", dy: -5 }
    },

    markLast: {
        x: { align: "left" },
        y: { align: "bottom" }
    },

    delta: {
        x: { align: "center" },
        y: { align: "top", dy: 35 }
    }
};
